/**
 * Poll until a Supabase Storage public URL returns a readable image.
 * Upload APIs can resolve before the object is reachable at the CDN edge.
 */
export async function waitForPublicImage(url, { attempts = 15, intervalMs = 400 } = {}) {
  if (!url) {
    throw new Error('Missing public image URL');
  }

  let lastStatus = 0;

  for (let attempt = 0; attempt < attempts; attempt += 1) {
    try {
      const bustUrl = `${url}${url.includes('?') ? '&' : '?'}cb=${Date.now()}`;
      const response = await fetch(bustUrl, { cache: 'no-store' });
      lastStatus = response.status;
      const contentType = response.headers.get('content-type') || '';

      if (response.ok && contentType.startsWith('image/')) {
        return url;
      }
    } catch {
      /* retry */
    }

    if (attempt < attempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }
  }

  throw new Error(
    `Uploaded image not publicly reachable (last HTTP ${lastStatus || 'error'})`
  );
}
